import { solicitudActividadService } from './solicitudActividadService';
import { supabase, ProductoActividad } from '../lib/supabase';

export const productoActividadService = {
  async getByActividad(actividadId: string): Promise<ProductoActividad[]> {
    const { data, error } = await supabase
      .from('productos_actividad')
      .select('*')
      .eq('actividad_id', actividadId)
      .order('nombre_producto', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<ProductoActividad | null> {
    const { data, error } = await supabase
      .from('productos_actividad')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async create(producto: Pick<ProductoActividad, 'actividad_id' | 'nombre_producto' | 'precio_unitario' | 'stock_inicial'>): Promise<ProductoActividad> {
    const id = crypto.randomUUID();
    const datos = { actividad_id: producto.actividad_id, nombre_producto: producto.nombre_producto,
      precio_unitario: producto.precio_unitario, stock_inicial: producto.stock_inicial };
    return solicitudActividadService.ejecutarContrato<ProductoActividad>('crear_producto',
      { p_id: id, p_datos: datos }, { id, datos });
  },

  async update(id: string, cambios: Partial<Pick<ProductoActividad, 'nombre_producto' | 'precio_unitario' | 'stock_inicial'>>): Promise<ProductoActividad> {
    return solicitudActividadService.ejecutarContrato<ProductoActividad>('editar_producto',
      { p_id: id, p_cambios: cambios }, { id, cambios });
  },



  async delete(id: string): Promise<void> {
    await solicitudActividadService.ejecutarContrato('eliminar_producto', { p_id: id }, { id });
  }
};
